import Image from 'next/image';
import React, {useState} from 'react';
import SearchBar from "@/components/Faq/SearchBar";

interface FaqLayoutProps {
    children: React.ReactNode;
}

const FaqLayout = ({ children }: FaqLayoutProps) => {
    const [query, setQuery] = useState<string>("");

    return (
        <div className="products-page-wrapper w-full mt-[80px]">
            <div className="md:container max-lg:px-4">
                <div className="relative md:rounded-2xl md:overflow-hidden">
                    {/* Immagine di sfondo */}
                    <div className="relative min-h-96 max-sm:min-h-56  w-full">
                        <Image
                            src="/banner-faq.webp"
                            alt="hero image"
                            layout="fill"
                            objectFit="cover"
                            className="rounded-2xl"
                        />
                    </div>
                    {/* Overlay nero */}
                    <div className="absolute inset-0 z-10 bg-black/40 rounded-2xl"></div>
                    {/* Contenuto */}
                    <div className="absolute inset-0 z-10 max-w-4xl mx-auto py-4">
                        <div className="h-full text-center flex flex-col justify-center space-y-lg p-6">
                            <h1 className="text-2xl font-bold lg:text-4xl w-full text-white">Siamo qui per te, sempre a disposizione, H24</h1>
                            <SearchBar />

                        </div>
                    </div>
                </div>
            </div>
            <div className="content py-10">
                {children}
            </div>
        </div>
    );
};

export default FaqLayout;
